function AppointmentType(axios, baseUrl) {
    this.axios = axios;
    this.baseUrl = `${baseUrl}appointmentType`;

    this.get = function(id) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/${id}`);
    }
    this.getAll = function() {
        let self = this;
        return self.axios.get(`${self.baseUrl}`);
    }
    this.filterByName = function(name) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/filterByName/${name}`);
    }
    this.add = function(model) {
        let self = this;
        return self.axios.post(`${self.baseUrl}`, model);
    }
    this.update = function(model) {
        let self = this;
        return self.axios.put(`${self.baseUrl}`, model);
    }
}

export default AppointmentType